import React, { Fragment } from 'react';

const escapeShortCodes = (text: string) => {
  if (typeof text !== 'string') {
    return null;
  }
  const replaceA = (text ?? '').split('[!').join('[');
  const replaceB = replaceA.split('!/]').join('/]');
  const replaceC = replaceB.split('[/!').join('[/');
  return replaceC;
  // using split/join because for some reason replaceAll fails for backstop
  // tests but not for backstop storybook?
  // if anyone can tell me why, I'd appreciate it.
  // return (text ?? '').replaceAll('[!', '[').replaceAll('!/]', '/]')
  //   .replaceAll('[/!', '[/');
};

const replaceValues = (text: string, values?: Record<string, string>) => {
  if (values == null) {
    return text;
  }
  return text.replace(/{(?<value>[^{]*)}/g, (_, match) => {
    return values[match];
  });
};

const nl2br = (string: string) =>
  (string ?? '')
    .split('\n')
    // @ts-ignore typescript cant figure typing out
    // eslint-disable-next-line react/no-array-index-key
    .reduce((prev, cur, i) => [prev, <br key={i} />, cur]);

const formatText = (text: string, newline: boolean | Element | undefined, values?: Record<string, string>) => {
  const formattedText = replaceValues(escapeShortCodes(text) ?? '', values);
  if (newline === false) {
    return formattedText;
  }
  return nl2br(formattedText);
};

interface OuterProps {
  text?: string | undefined;
  nl2br?: boolean | Element;
  values?: Record<string, string>;
}
const Text = ({ text, nl2br, values }: OuterProps) => <Fragment>{formatText(text ?? '', nl2br, values)}</Fragment>;

Text.displayName = 'Text';

export default Text;
